export default {
    apiKey: "AIzaSyCrVIb9x8GTgDtNLw6XU57HUkwN7zPXYHA",
    authDomain: "whatsappclone-2ecf3.firebaseapp.com",
    projectId: "whatsappclone-2ecf3",
    storageBucket: "whatsappclone-2ecf3.appspot.com",
    messagingSenderId: "784232343830",
    appId: "1:784232343830:web:64507d73fdc51756224837"
  };